export default "__VITE_ASSET__6020e4a5__"